import axios from 'axios';
import api from '../api';

export default {
    CREATE_CUSTOM_FIELD: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.customfield.CREATE_CUSTOM_FIELD(), data)
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },
    DELETE_CUSTOEM_FILED_BY_TAG: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.customfield.DELETE_CUSTOEM_FILED_BY_TAG(), data)
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },
    GET_ALL_CUSTOM_FIELD: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.customfield.GET_ALL_CUSTOM_FIELD())
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },
    UPDATE_CUSTOM_FIELD: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.customfield.UPDATE_CUSTOM_FIELD(id), data)
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },
    GET_CUSTOM_FIELD_BY_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.customfield.GET_CUSTOM_FIELD_BY_ID(id))
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },

    GET_CUSTOM_FIELD_BY_TASK_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(id))
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },

    DELETE_PROPERTY: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.customfield.DELETE_PROPERTY(id))
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },

    GET_PROPERTY_BY_BOARD_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.property.GET_PROPERTY_BY_BOARD_ID(id))
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },

    DELETE_CUSTOEM_FILED: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.customfield.DELETE_CUSTOEM_FILED(id))
                .then((res) => resolve(res))
                .catch((e) => reject(e));
        });
    },
};
